type SentryEnv = {
  vercelEnv?: string;
  commitSha?: string;
  mode: string;
};

export const SENTRY_REPLAY_PRIVACY = {
  maskAllText: true,
  maskAllInputs: true,
  blockAllMedia: true,
} as const;

export function resolveSentryEnvironment(env: Pick<SentryEnv, "vercelEnv" | "mode">): string {
  const vercelEnv = env.vercelEnv?.trim();
  if (vercelEnv) return vercelEnv;
  return env.mode;
}

export function resolveSentryRelease(commitSha?: string): string | undefined {
  const sha = commitSha?.trim();
  return sha || undefined;
}

export function getSentryEnvironment(): string {
  return resolveSentryEnvironment({
    vercelEnv: import.meta.env.VITE_VERCEL_ENV,
    mode: import.meta.env.MODE,
  });
}

export function getSentryRelease(): string | undefined {
  return resolveSentryRelease(import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA);
}
